import { render, staticRenderFns } from "./wx-image.vue?vue&type=template&id=047fdea9&scoped=true&"
import script from "./wx-image.vue?vue&type=script&lang=js&"
export * from "./wx-image.vue?vue&type=script&lang=js&"
import style0 from "./wx-image.vue?vue&type=style&index=0&id=047fdea9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047fdea9",
  null
  
)

export default component.exports